import '@fontsource/geist-sans/400.css'
import '@fontsource/geist-sans/500.css'
import '@fontsource/geist-sans/600.css'
import React from 'react';
import ReactDOM from 'react-dom/client'
import App from './App';
import { SWRConfig } from 'swr';
import { fetcher } from './api';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SWRConfig
        value={{
          fetcher: fetcher,
          revalidateOnFocus: false,
          shouldRetryOnError: true,
          dedupingInterval: 1000,
          onError: (error, key) => {
            console.error('🔴 SWR global error:', { error, key });
          }
        }}
      >
        <App />
      </SWRConfig>
    </ThemeProvider>
  </React.StrictMode>
);